//libs
import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from "moment";

class HistoryTable extends Component  {

    render() {

        let {loading, title, data} = this.props;
        let x = null;
        for(x in data){
            data[x].date_user = moment(data[x].date).format('YYYY-MM-DD - HH:mm')+ " \n " + data[x].user
        }
        return (
            <div>
                <h2>{title}</h2>
                <ReactTable
                    data={data}
                    loading={loading}
                    loadingText="Laddar..."
                    minRows="0"
                    pageSize="200"
                    className="search-wheelset-table history-table"
                    showPagination={false}
                    noDataText="Inga hjul hittades"
                    columns={[
                        {
                            Header: "Datum - User",
                            accessor: "date_user",
                            maxWidth:180,
                            style: {
                                overflow: "visible",
                                whiteSpace:"normal"
                            }
                        },
                        {
                            Header: "Händelse",
                            accessor: "comment",
                            style: {
                                overflow: "visible",whiteSpace:"normal"
                            }

                        }
                    ]}
                />
            </div>
        )
    }
}
export default HistoryTable;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Search/HistoryTable.js